import type { ApplicationInsights } from "@microsoft/applicationinsights-web"
import { ErrorTag } from "src/types"

const isDevBuild = process.env?.NODE_ENV === "development"

export function trackException(
  e: unknown,
  tagKey: keyof typeof ErrorTag,
  customAttributes: Record<string, unknown> = {},
  applicationInsights: ApplicationInsights,
) {
  const tag = ErrorTag[tagKey]

  const isError = Object.prototype.toString.call(e) === "[object Error]"
  const error = isError ? e as Error : new Error(typeof e === "string" ? e : tag)

  applicationInsights.trackException({
    error,
    properties: {
      tag,
      ...customAttributes,
    },
  })

  if (isDevBuild) {
    console.warn(e)
  }
}
